import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'RpcNotAvailable',
  props: {},

  data() {
    return {
      timeCounter: 0,
      isBlocked: true,
    };
  },
  computed: {
    parseToTimestamp() {
      let date = new Date(0);
      date.setSeconds(this.timeCounter);
      let timeString = date.toISOString().substr(15, 4);
      return timeString;
    },
    ...mapGetters([
      'servicesListLoading',
    ]),
  },

  created() {
    this.getTimeFromLocalStorage();
  },
  methods: {
    refresh() {
      this.$emit('refresh');
      this.$nextTick(() => {
        this.getTimeFromLocalStorage();
      })
    },
    getTimeFromLocalStorage() {
      if (localStorage.getItem('rpcAccess') !== null) {
        const rpcAccess = JSON.parse(localStorage.getItem('rpcAccess'));
        const savedDate = moment(rpcAccess.timestamp);
        const nowDate = moment();
        const duration = moment.duration(savedDate.diff(nowDate));
        const minutes = duration.asMinutes();
        const seconds = minutes / 0.016667;
        this.timeCounter = seconds;
        this.startCounting();
      }
    },
    startCounting() {
      if (this.timeCounter > 0) {
        setTimeout(() => {
          this.timeCounter -= 1;
          this.startCounting();
        }, 1000);
      } else {
        this.isBlocked = false;
        localStorage.removeItem('rpcAccess');
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Services/RpcNotAvailable/component.js